"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

const DEFAULT_TOAST_TITLE = "\u0413\u043e\u0442\u043e\u0432\u043e";

type ToastItem = {
  id: number;
  title: string;
  message: string;
  actionHref?: string;
  actionLabel?: string;
};

export function CartToastHost() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    function handleToast(event: Event) {
      const customEvent = event as CustomEvent<{
        title?: string;
        message?: string;
        actionHref?: string;
        actionLabel?: string;
      }>;

      const title = customEvent.detail?.title?.trim() || DEFAULT_TOAST_TITLE;
      const message = customEvent.detail?.message?.trim();

      if (!message) {
        return;
      }

      const id = Date.now();
      setItems((current) => [
        ...current,
        {
          id,
          title,
          message,
          actionHref: customEvent.detail?.actionHref,
          actionLabel: customEvent.detail?.actionLabel
        }
      ]);

      window.setTimeout(() => {
        setItems((current) => current.filter((item) => item.id !== id));
      }, 2600);
    }

    window.addEventListener("bitstone:toast", handleToast as EventListener);
    return () => window.removeEventListener("bitstone:toast", handleToast as EventListener);
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <div className="cart-toast-stack" aria-live="polite" aria-atomic="true">
      {items.map((item) => (
        <div className="cart-toast" key={item.id}>
          <div className="cart-toast__content">
            <div className="cart-toast__head">
              <span className="cart-toast__icon" aria-hidden="true">
                +
              </span>
              <strong className="cart-toast__title">{item.title}</strong>
            </div>

            <span className="cart-toast__message">{item.message}</span>

            {item.actionHref && item.actionLabel ? (
              <div className="cart-toast__actions">
                <Link
                  className="cart-toast__button"
                  href={item.actionHref}
                  onClick={() =>
                    setItems((current) => current.filter((toast) => toast.id !== item.id))
                  }
                >
                  {item.actionLabel}
                </Link>
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
